<template>
	<div>
		<v-card class="ma-2 mb-4">
			<v-toolbar :color="color" dark>
				<v-toolbar-title>
					<v-icon class="mr-3">business</v-icon>
					Projekty
				</v-toolbar-title>
			</v-toolbar>
			<v-alert :value="projects !== null && projects.length === 0" type="info">
				Nie ma żadnych projektów!
			</v-alert>
			<v-list two-line v-if="projects !== null">
				<template v-for="(project) in projects">
					<v-list-tile :key="project.id" avatar>
						<v-list-tile-avatar>
							<v-icon color="primary">business</v-icon>
						</v-list-tile-avatar>
						<v-list-tile-content>
							<v-list-tile-title v-html="getTileTitle(project)"></v-list-tile-title>
							<v-list-tile-sub-title v-html="getTileSubtitle(project)"></v-list-tile-sub-title>
							<v-list-tile-action-text>
								<td>
              {{ getTileActionText(project) }}
            <v-tooltip bottom v-if="project.agencyProjectStatus == 'ANNULLED'">
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="red"
                  left
                  style="margin-left: 5px"
                  >cancel</v-icon>
              </template>
              <span>
				{{ project.annulationCause }}
			</span>
            </v-tooltip>
            </td>
							</v-list-tile-action-text>
						</v-list-tile-content>
						<v-list-tile-action
							v-if="(roles.isAdministrator() || roles.isLocalAdministrator() || (roles.isDepartmentEmployee() && (userDomainRole === 'SECRETARY' || userDomainRole === 'MAIN_SECRETARY'))) && !project.hideFromUser">
							<egranty-icon-button
								:icon="getSupervisorIcon(project)"
								:color="'primary'"
								:label="getDialogTitle(project)"
								for="agency-all-projects-add-supervisor"
								id="agency-all-projects-add-supervisor"
								@click="selectedProject = project; selectSupervisorDialog = true"
								:disabled="project.agencyProjectStatus !== 'APPROVED'"/>
						</v-list-tile-action>
						<v-list-tile-action
							v-if="(roles.isAdministrator() || roles.isLocalAdministrator() || (roles.isDepartmentEmployee() && secretary)) && !project.hideFromUser">
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn icon

										@click="goToProjectPanel(project)">
										<v-icon v-on="on">
											business
										</v-icon>
									</v-btn>
								</template>
								<span>Panel projektu</span>
							</v-tooltip>
						</v-list-tile-action>
						<v-list-tile-action v-if="!project.hideFromUser">
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn icon
										@click="showProject(project)">
										<v-icon v-on="on">
											description
										</v-icon>
									</v-btn>
								</template>
								<span>Podgląd</span>
							</v-tooltip>
						</v-list-tile-action>
					</v-list-tile>
				</template>
			</v-list>
		</v-card>
		<v-dialog v-model="selectSupervisorDialog" scrollable max-width="500px">
			<v-card>
				<v-toolbar color="primary" class="mb-2">
					<v-toolbar-title style="font-size: 24px; font-weight: 400">
						{{getDialogTitle(this.selectedProject)}}
					</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-btn icon @click="selectedUser = null; selectedProject = null; selectSupervisorDialog = false">
						<v-icon>close</v-icon>
					</v-btn>
				</v-toolbar>
				<template>
					<v-autocomplete
						clearable
						style="margin-left: 20px; margin-right: 20px;"
						v-model="selectedUser"
						label="Opiekun projektu"
						aria-label="supervisor name"
						for="agency-projects-list-select-supervisor"
						id="agency-projects-list-select-supervisor"
						:items="supervisors"
						item-text="fullName"
						return-object
					>
					</v-autocomplete>
				</template>
				<v-card-actions style="padding: 16px">
					<v-spacer></v-spacer>
					<v-btn text @click="assignSupervisorToSelectedProject(); selectSupervisorDialog = false">
						Wybierz
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import EgrantyIconButton from "../../../genericComponents/EgrantyIconButton";
	import {AgencyProject} from "@/api/generated/AgencyProject";
	import {User} from "@/api/generated/User";
	import { Api } from '@/api';


	export default {
		name: "AgencyContestProjectsListView",
		components: {EgrantyIconButton},

		data() {
			return {
				dialog: false,
				selectSupervisorDialog: false,
				supervisors: [],
				selectedUser: null,
				selectedProject: null,
				search: {},
				userDomainRole: undefined,
				projects: null,
				contestId: this.$route.params.id
			};
		},
		props: {
			color: {type: String, default: "amber"},
			secretary: Boolean,
		},

		async mounted() {
			await Api.get(this, "/agency-contest/user-role?contestId=".concat(this.contestId), success => {
				this.userDomainRole = success;
			});
		},

		created() {
			AgencyProject.getApprovedProjectsByContest(this, this.contestId, (response) => {
				this.projects = response.sort((p1, p2) => p2.agencyProjectCode.localeCompare(p1.agencyProjectCode));
			});
			this.getSupervisors();
		},

		methods: {
			getSupervisors() {
				User.getListAgencyContestSupervisors(this, this.$route.params.id, success => {
					this.supervisors = success;
					this.supervisors.forEach(supervisor => {
						this.$set(supervisor, "fullName", supervisor.name + " " + supervisor.surname);
					});
				}, () => {
					this.$messagesBus.$emit("error", "Nie udało się wczytać listy opiekunów");
				});
			},
			getTileTitle(project) {
				return project.agency.name + ": " + project.agencyProjectData.title;
			},
			getTileSubtitle(project) {
				let ret = "[" + project.agencyProjectCode + "] | ";
				if (project.supervisor === null) {
					return ret + "Nie przydzielono opiekuna";
				} else {
					return ret + "Opiekun: " + project.supervisor.name + " " + project.supervisor.surname;
				}
			},
			getTileActionText(project) {
				switch (project.agencyProjectStatus) {
					case "NEW":
						return "Projekt w trakcie realizacji";
					case "ANNULLED":
						return "Projekt Anulowany";	
				}
			},
			supervisorButtonClicked(project) {
				this.dialog = true;
				this.selectedProject = project;
				this.selectedUser = this.selectedProject.supervisor;
			},
			assignSupervisorToSelectedProject() {
				AgencyProject.postAgencyProjectSupervisor(this, this.selectedProject.id, this.selectedUser.id, () => {
					let project = this.projects.find(p => p.id === this.selectedProject.id);
					this.$set(project, "supervisor", this.selectedUser);
					this.$messagesBus.$emit("success", "Przypisano opiekuna do projektu");
					this.selectedUser = null;
					this.selectedProject = null;
				}, () => {
					this.$messagesBus.$emit("error", "Nie udało się przypisać opiekuna do projektu");
					this.selectedUser = null;
					this.selectedProject = null;
				});
			},
			getDialogTitle(project) {
				if (project !== null && project.supervisor !== null) {
					return "Zmień opiekuna";
				} else {
					return "Wskaż opiekuna";
				}
			},
			getSupervisorIcon(project) {
				if (project !== null && project.supervisor !== null) {
					return "group_add";
				} else {
					return "person_add";
				}
			},

			goToProjectPanel(project) {
				this.$router.push("/app/agency-contest/".concat(this.contestId).concat("/project-panel/").concat(project.id));
			},

			showProject(project) {
				this.$router.openInNewTab("/view/agency-contest/".concat(this.contestId).concat("/project/").concat(project.agency.id).concat("/").concat(project.id));
			},
		},
	};
</script>

<style scoped>

</style>
